import {
    BackButton,
    classNames,
    CodeForm,
    layout,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {commonStyles} from "./commonStyles";
import {useLocalization} from "../i18n";

type CodeViewProps = {
    onBack: () => void;
    title: string;
    description: string;
    onVerify: (code: string) => Promise<void>;
}

export function CodeView({onBack, title, description, onVerify}: CodeViewProps) {
    const {t} = useLocalization();
    return (
        <View>
            <ViewHeader className={commonStyles.viewHeader}>
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>

                <ViewHeaderItem fill>
                    <ViewTitle>{title}</ViewTitle>
                    <ViewDescription>{description}</ViewDescription>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.center, commonStyles.selectionViewContent)}>
                <CodeForm strings={t} onVerify={onVerify}/>
            </ViewContent>
        </View>
    );
}
